<!-- Page Header -->
<div class="d-flex justify-content-between align-items-center mb-4">
  <div>
    <h1 class="h2 mb-1 fw-bold">Activity</h1>
    <p class="text-muted mb-0">View all recent activity for your organization.</p>
  </div>
  <div class="d-flex gap-2">
    <!-- Unseen filter toggle -->
    <button
      class="btn"
      [class.btn-primary]="showUnseenOnly()"
      [class.btn-outline-secondary]="!showUnseenOnly()"
      (click)="toggleUnseenFilter()"
      [disabled]="isLoadingActivities()"
    >
      <i class="bi bi-eye me-2"></i>
      Unread
      <span *ngIf="unseenCount() > 0" class="badge bg-danger ms-1">{{ unseenCount() }}</span>
    </button>
    <button class="btn btn-outline-primary" (click)="refresh()" [disabled]="isLoadingActivities()">
      <i class="bi bi-arrow-clockwise me-2" [class.spin]="isLoadingActivities()"></i>
      Refresh
    </button>
  </div>
</div>

<!-- Activity List -->
<div class="card">
  <div class="card-body p-0">
    <!-- Loading skeleton for initial load -->
    <div *ngIf="isLoadingActivities() && isInitializing()" class="activity-list p-3">
      <div *ngFor="let i of [1, 2, 3, 4, 5]" class="activity-item">
        <div class="activity-icon skeleton-loader skeleton-icon"></div>
        <div class="activity-content">
          <div class="skeleton-loader skeleton-text mb-2"></div>
          <div class="skeleton-loader skeleton-text-sm"></div>
        </div>
      </div>
    </div>

    <!-- Activity list -->
    <div *ngIf="!isLoadingActivities() || !isInitializing()" class="activity-list p-3">
      <div
        *ngFor="let activity of activities(); let last = last"
        class="activity-item"
        [class.activity-item-enter]="isNewActivity(activity.id)"
        [class.activity-item-clickable]="hasResourceLink(activity)"
        [class.mb-0]="last"
        (click)="hasResourceLink(activity) && navigateToResource(activity)"
        [attr.role]="hasResourceLink(activity) ? 'button' : null"
        [attr.tabindex]="hasResourceLink(activity) ? 0 : null"
      >
        <div class="activity-icon">
          <i [class]="getActivityIconClass(activity)"></i>
        </div>
        <div class="activity-content">
          <p class="activity-message mb-0 fw-medium">{{ activity.message }}</p>
          <small class="text-muted">{{ getRelativeTime(activity.createdAt) }}</small>
        </div>
        <div *ngIf="hasResourceLink(activity)" class="activity-link-indicator">
          <i class="bi bi-chevron-right text-muted"></i>
        </div>
      </div>

      <!-- Empty state -->
      <div *ngIf="activities().length === 0" class="text-center text-muted py-5">
        <i class="bi bi-activity fs-1 d-block mb-3 opacity-50"></i>
        <h5 *ngIf="!showUnseenOnly()">No activity yet</h5>
        <h5 *ngIf="showUnseenOnly()">All caught up!</h5>
        <p class="mb-0" *ngIf="!showUnseenOnly()">Activity will appear here as you use the platform.</p>
        <p class="mb-0" *ngIf="showUnseenOnly()">You've seen all recent activity.</p>
      </div>
    </div>

    <!-- Load more button -->
    <div *ngIf="hasMore() && activities().length > 0" class="p-3 border-top text-center">
      <button
        class="btn btn-outline-primary"
        (click)="loadMore()"
        [disabled]="isLoadingActivities()"
      >
        <span *ngIf="isLoadingActivities()">
          <span class="spinner-border spinner-border-sm me-2"></span>
          Loading...
        </span>
        <span *ngIf="!isLoadingActivities()">
          Load More
        </span>
      </button>
    </div>
  </div>
</div>
